import styled, { keyframes } from "styled-components";

const appear = keyframes`
  from { opacity: 0; transform: translate(-50%, -50%) translateY(6px) scale(.98); }
  to { opacity: 1; transform: translate(-50%, -50%) translateY(0) scale(1); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100dvw;
  height: 100dvh;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
`;

export const Dialog = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center;
  animation: ${appear} 160ms ease both;
  width: min(600px, calc(100vw - 32px));
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(2, 6, 23, 0.22);
  padding: 18px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
`;

export const Desc = styled.p`
  margin-top: -6px;
  font-size: 13px;
  color: #475569;
`;

export const ApiError = styled.div`
  margin-top: 4px;
  padding: 10px 12px;
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
`;

export const ConfirmLabel = styled.label`
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
`;

export const ConfirmInput = styled.input`
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  color: #0f172a;
  background: #fff;
  &:hover {
    background: #f8fafc;
  }
  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }
`;

export const Select = styled.select`
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 10px;
  font-size: 13px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }
`;

export const Actions = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const Button = styled.button`
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  font-weight: 800;
  border: 1px solid transparent;
  cursor: pointer;

  &[data-variant="ghost"] {
    background: #f8fafc;
    color: #0f172a;
    border-color: #e2e8f0;
    &:hover {
      background: #eef2f7;
    }
  }

  &[data-variant="primary"] {
    background: #2563eb;
    color: #fff;
    &:hover {
      background: #1d4ed8;
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
